import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Portal,
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useSubmenu } from "../../hooks/useSubmenu";
import { NavLink } from "../../common/NavLink";
import { SubOutlet } from "../SubOutlet";
import { CalendarMonth } from "@mui/icons-material";
import { useSchedulesConnection } from "../../data/schedules/useSchedulesConnection";

export function SchedulePage() {
  const { submenu } = useSubmenu();
  useSchedulesConnection();

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Portal container={submenu}>
        <List
          dense
          subheader={
            <ListSubheader component="div" inset>
              Подменю
            </ListSubheader>
          }
        >
          <ListItemButton to="/schedule/" component={NavLink}>
            <ListItemIcon>
              <CalendarMonth />
            </ListItemIcon>
            <ListItemText primary="График" />
          </ListItemButton>
          <ListItemButton to="/schedule/special-shifts" component={NavLink}>
            <ListItemIcon>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Резерви и Персонални" />
          </ListItemButton>
        </List>
      </Portal>

      <SubOutlet />
    </div>
  );
}
